import { motion } from 'framer-motion';
import MarkdownWord from 'components/ui/MarkdownWord';
import Icon from '../../../components/AppIcon';

const typeConfig = {
  reject: { icon: 'X', color: 'text-red-600', bg: 'bg-red-50' },
  leave: { icon: 'Calendar', color: 'text-amber-600', bg: 'bg-amber-50' },
  attendance: { icon: 'ClockArrowDown', color: 'text-emerald-600', bg: 'bg-emerald-50' },
  checkout: { icon: 'ClockArrowUp', color: 'text-red-600', bg: 'bg-red-50' },
  listing: { icon: 'List', color: 'text-blue-600', bg: 'bg-blue-50' },
  system: { icon: 'Settings', color: 'text-slate-600', bg: 'bg-slate-50' },
};

export default function ActivityItem({ item, index }) {
  const config = typeConfig[item.type] || typeConfig.system;

  return (
    <motion.div
      initial={{ opacity: 0, x: -8 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: index * 0.05 }}
      className="flex items-start gap-3 py-3 border-b border-slate-50 last:border-0"
    >
      <div className={`${config.bg} rounded-lg p-1.5 mt-0.5`}>
        <Icon name={config.icon} size={14} className={config.color} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm text-slate-700">
          <span className="font-semibold text-slate-900">{item.actor_name}</span>
        </p>
        <p className="text-xs text-slate-500 mt-0.5">
          <MarkdownWord content={item.target} />
        </p>
        <p className="text-[10px] text-slate-400 mt-1">{item.time}</p>
      </div>
    </motion.div>
  );
}
